import { render } from "./ResourceModal.vue?vue&type=template&id=3511aa76"
import script from "./ResourceModal.vue?vue&type=script&lang=js"
export * from "./ResourceModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__